/**
 * Normalize values from the API or forms to YYYY-MM-DD for <input type="date">.
 * Prefer the calendar portion of ISO strings; do not parse arbitrary strings with
 * `new Date()` (timezone shifts). Backend pond dates use DATEONLY (YYYY-MM-DD).
 */
export function toDateInputValue(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const m = value.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '' : value.toISOString().split('T')[0];
  }
  return '';
}
